import { useState } from "react";
import type { Translate } from "../lib/i18n.js";
import { dismissInstallHint, installHintDismissed, platformInfo } from "../lib/install.js";

/** One quiet line under the clock: install the app. Gone once installed or waved away. */
export function InstallHint({ t }: { t: Translate }) {
  const [hidden, setHidden] = useState(() => platformInfo().standalone || installHintDismissed());
  if (hidden) return null;
  return (
    <div className="installhint">
      <a href="/install">{t("installHint")}</a>
      <button
        type="button"
        onClick={() => {
          dismissInstallHint();
          setHidden(true);
        }}
      >
        {t("installLater")}
      </button>
    </div>
  );
}
